module.exports = __webpack_public_path__ + "assets/4bfefb7e899f1231c94ec6609f0087c7.mp3";